import { useMemo } from 'react';
import { linkedProjectColumns } from './columns';
import Table from '../../../components/table/table';
import useCompanies from '../../../hooks/useCompanies';

const ForecastedProjects = ({ projects, filtersRange }) => {
  const { companies } = useCompanies();
  const companiesMap = useMemo(() => {
    if (!companies) return {};
    return companies.reduce((map, company) => {
      map[company.companyID] = company.companyName;
      return map;
    }, {});
  }, [companies]);

  const monthlyTotals = useMemo(() => {
    return filtersRange.map((month) => {
      return projects
        .reduce((sum, project) => {
          const value = project.formattedSchedule.find((x) => x.date === month)?.value || 0;
          return sum + value;
        }, 0)
        .toFixed(2);
    });
  }, [projects, filtersRange]);

  const projectsWithClientName = useMemo(() => {
    return projects.map((project) => ({
      ...project,
      clientName: companiesMap[project.client] || '',
      // Ensure projectLead is present for the table
      projectLead: project.projectLead || project.lead || '',
      total: project.formattedSchedule.reduce((sum, item) => {
        if (filtersRange.includes(item.date)) {
          return sum + item.value;
        } else {
          return sum;
        }
      }, 0),
    }));
  }, [projects, companiesMap]);

  return (
    <div className="forecasted-table">
      <Table
        data={projectsWithClientName}
        columns={linkedProjectColumns(filtersRange, monthlyTotals, companiesMap)}
        hasFooter={true}
        stickyHeader={true}
        rowBackground="white"
        rowHover={true}
        useUniformBackground={true}
      />
    </div>
  );
};

export default ForecastedProjects;
